import { PLAYLIST_TAGS_RESOURCE, DEVICE_TAGS_RESOURCE, ASSETS_TAGS_RESOURCE } from "../api/resources";
import {
  addResource,
  deleteResource,
  fetchResource,
  updateResource,
} from "./remote";
import {
  PLAYLISTS_RESOURCE,
  PLAYLIST_ITEMS_RESOURCE,
  CHANNELS_RESOURCE,
} from "../api/resources";
import {
  UPDATE_PLAYLIST_TAGS_REQUEST,
  UPDATE_PLAYLIST_TAGS_ACCEPT,
  UPDATE_PLAYLIST_TAGS_DENY,
  BULK_PLAYLISTS_UPDATE_REQUEST,
  BULK_PLAYLISTS_UPDATE_ACCEPT,
  BULK_PLAYLISTS_UPDATE_DENY,
} from "../constants/actionTypes";
import {
  bulkDeletePlaylist,
  bulkUpdatePlaylist,
  bulkDeletePlaylistItems,
} from "./playlist";
import { bulkDeleteChannel, bulkUpdateChannel } from "./channel";

export const fetchTags = fetchResource(PLAYLIST_TAGS_RESOURCE);
export const addTag = addResource(PLAYLIST_TAGS_RESOURCE);
export const cloneTag = addResource(PLAYLIST_TAGS_RESOURCE, "clone");
export const updateTag = updateResource(PLAYLIST_TAGS_RESOURCE);
export const deleteTag = deleteResource(PLAYLIST_TAGS_RESOURCE);

export const playlistUpdateTagsRequest = (
  title,
  operation,
  resourceType,
  id,
  tags
) => ({
  type: UPDATE_PLAYLIST_TAGS_REQUEST,
  title,
  operation,
  resourceType,
  id,
  tags,
});

export const playlistUpdateTagsAccept = () => ({
  type: UPDATE_PLAYLIST_TAGS_ACCEPT,
});

export const playlistUpdateTagsDeny = () => ({
  type: UPDATE_PLAYLIST_TAGS_DENY,
});

export const bulkUpdateRequest = (
  title,
  message,
  operation,
  resourceType,
  id,
  playlists
) => ({
  type: BULK_PLAYLISTS_UPDATE_REQUEST,
  title,
  message,
  resourceType,
  operation,
  id,
  playlists,
});

// export const bulkPlaylistsUpdateAccept = () => ({
//     type: BULK_PLAYLISTS_UPDATE_ACCEPT,
// });

export const bulkPlaylistsUpdateDeny = () => ({
  type: BULK_PLAYLISTS_UPDATE_DENY,
});

export const bulkPlaylistsUpdateAccept =
  (operation, resourceType, data) => (dispatch) => {
    dispatch({ type: BULK_PLAYLISTS_UPDATE_ACCEPT });

    if (operation === "DELETE") {
      switch (resourceType) {
        case PLAYLISTS_RESOURCE:
          return dispatch(bulkDeletePlaylist(data));
        case PLAYLISTS_RESOURCE_V2:
          return dispatch(bulkDeletePlaylist(data));
        case PLAYLIST_ITEMS_RESOURCE:
          return dispatch(bulkDeletePlaylistItems(data));
        case CHANNELS_RESOURCE:
          return dispatch(bulkDeleteChannel(data));
      }
    }

    if (operation === "PATCH") {
      switch (resourceType) {
        case PLAYLISTS_RESOURCE:
          return dispatch(bulkUpdatePlaylist(data));
        case PLAYLISTS_RESOURCE_V2:
          return dispatch(bulkUpdatePlaylist(data));
        case CHANNELS_RESOURCE:
          return dispatch(bulkDeletePlaylist(data));
      }
    }
  };


// DEVICE TAGS
export const fetchDeviceTags = fetchResource(DEVICE_TAGS_RESOURCE);
export const addDeviceTag = addResource(DEVICE_TAGS_RESOURCE);
export const updateDeviceTag = updateResource(DEVICE_TAGS_RESOURCE);
export const deleteDeviceTag = deleteResource(DEVICE_TAGS_RESOURCE);

// ASSET TAGS
export const fetchAssetTags = fetchResource(ASSETS_TAGS_RESOURCE);
export const addAssetTag = addResource(ASSETS_TAGS_RESOURCE);
export const updateAssetTag = updateResource(ASSETS_TAGS_RESOURCE);
export const deleteAssetTag = deleteResource(ASSETS_TAGS_RESOURCE);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/tagActions.js